// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChangeAdminForm-space1-GDWDq {
	margin-bottom: 6px !important;
}

.ChangeAdminForm-space2-nGuZM {
	margin-bottom: 12px !important;
}

.ChangeAdminForm-space3-QQjcU {
	margin-bottom: 18px !important;
}

.ChangeAdminForm-space4-ZeU_9 {
	margin-bottom: 24px !important;
}

.ChangeAdminForm-space5-egjwl {
	margin-bottom: 30px !important;
}

.ChangeAdminForm-space6-CdB5_ {
	margin-bottom: 36px !important;
}

.ChangeAdminForm-space7-fmGZR {
	margin-bottom: 42px !important;
}

.ChangeAdminForm-space8-qA706 {
	margin-bottom: 48px !important;
}

.ChangeAdminForm-spaceTop1-a69MF {
	margin-top: 6px !important;
}

.ChangeAdminForm-spaceTop2-lZk7g {
	margin-top: 12px !important;
}

.ChangeAdminForm-spaceTop3-A5tc_ {
	margin-top: 18px !important;
}

.ChangeAdminForm-spaceTop4-Xh4_t {
	margin-top: 24px !important;
}

.ChangeAdminForm-spaceTop5-Mhz_M {
	margin-top: 30px !important;
}

.ChangeAdminForm-spaceTop6-OtApW {
	margin-top: 36px !important;
}

.ChangeAdminForm-spaceTop7-rBPQh {
	margin-top: 42px !important;
}

.ChangeAdminForm-spaceTop8-jAouD {
	margin-top: 48px !important;
}

.ChangeAdminForm-noMargin-JDzRY {
	margin: 0px !important;
}

.ChangeAdminForm-padding1-dO8U3 {
	padding-bottom: 6px !important;
}

.ChangeAdminForm-padding2-TQ4KQ {
	padding-bottom: 12px !important;
}

.ChangeAdminForm-padding3-ZebCC {
	padding-bottom: 18px !important;
}

.ChangeAdminForm-padding4-o1J_W {
	padding-bottom: 24px !important;
}

.ChangeAdminForm-padding5-es6lB {
	padding-bottom: 30px !important;
}

.ChangeAdminForm-padding6-xSByg {
	padding-bottom: 36px !important;
}

.ChangeAdminForm-padding7-HUdT8 {
	padding-bottom: 42px !important;
}

.ChangeAdminForm-paddingTop1-sXHch {
	padding-top: 6px !important;
}

.ChangeAdminForm-paddingTop2-SwEp4 {
	padding-top: 12px !important;
}

.ChangeAdminForm-paddingTop3-DYx5K {
	padding-top: 18px !important;
}

.ChangeAdminForm-paddingTop4-yXCIJ {
	padding-top: 24px !important;
}

.ChangeAdminForm-paddingTop5-AXMnT {
	padding-top: 30px !important;
}

.ChangeAdminForm-paddingTop6-hiYqV {
	padding-top: 36px !important;
}

.ChangeAdminForm-paddingTop7-kMIJS {
	padding-top: 42px !important;
}

.ChangeAdminForm-noPadding-OiBL1 {
	padding: 0px !important;
}

.ChangeAdminForm-spaceMarginBottom0-LPmIa {
	margin-bottom: 0;
}

.ChangeAdminForm-textBold-hJe83 {
	font-weight: 500 !important;
}

.ChangeAdminForm-textBolder-gbz2B {
	font-weight: 700 !important;
}

.ChangeAdminForm-textNormal-ZnARA {
	font-weight: normal !important;
}

/*New Design Text Colors */

.ChangeAdminForm-textDarkBlue-xk8C0 {
	color: rgb(20, 39, 94) !important;
}

.ChangeAdminForm-textLightBlue-HDd0S {
	color: rgb(57, 87, 106) !important;
}

.ChangeAdminForm-textLightSandleGreen-jZ9MU {
	color: rgb(76, 86, 41) !important;
}

.ChangeAdminForm-textLightBrown-tqZE5 {
	color: rgb(115, 79, 33) !important;
}

.ChangeAdminForm-textMediumMaroon-qw9yY {
	color: rgb(87, 37, 51) !important;
}

.ChangeAdminForm-textBrown-QV5oC {
	color: rgb(160, 47, 24) !important;
}

.ChangeAdminForm-textMaroon-ePquF {
	color: rgb(155, 49, 67) !important;
}

.ChangeAdminForm-textDarkBrown-mnaAI {
	color: rgb(83, 18, 16) !important;
}

.ChangeAdminForm-textMediumBrown-DwXtP {
	color: rgb(142, 28, 10) !important;
}

.ChangeAdminForm-textSkyBlue-x6Qp9 {
	color: rgb(37, 117, 141) !important;
}

.ChangeAdminForm-textGray-_yLr_ {
	color: rgb(77, 65, 51) !important;
}

.ChangeAdminForm-errorMessage-T5nvt {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.ChangeAdminForm-userText-ctw1O {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.ChangeAdminForm-panelHeader-CiAXW {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.ChangeAdminForm-exportSection-ELEOW {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.ChangeAdminForm-exportSectionGridSub-OgKnf {
	grid-template-columns: 50% 49% !important;
}

.ChangeAdminForm-exportText-bn5Vy {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.ChangeAdminForm-exportLinkImg-buQe_ {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.ChangeAdminForm-exportImg-hlW1o {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.ChangeAdminForm-linkBtn-WAfu3 {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.ChangeAdminForm-table-COYnj {
	display: table;
}

.ChangeAdminForm-tableRow-kKNrr {
	display: table-row;
}

.ChangeAdminForm-tableCell-CPbop {
	display: table-cell;
	float: none;
}

.ChangeAdminForm-formGroup-bBxI3 {
	margin-bottom: 6px;
}

.ChangeAdminForm-marginTop0-TzFEA {
	margin-top: 0;
}

.ChangeAdminForm-marginBottom20-nIDTm {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.ChangeAdminForm-bannerImageBg-vR1DD {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.ChangeAdminForm-bannerDelete-rcQIj {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.ChangeAdminForm-exportLink-bu9tD {
	padding-top: 10px;
	padding-right: 10px;
}

.ChangeAdminForm-seachContent-sgtDD {
	padding-left: 0px;
	margin-bottom: 5px;
}

.ChangeAdminForm-marginBottom9-lAnEz {
	margin-bottom: 9px;
}

.ChangeAdminForm-spaceTop52-KIygE {
	margin-top: 52px;
}

.ChangeAdminForm-profileViewInner-RA5Lb {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.ChangeAdminForm-profileViewMain-QOvAb {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.ChangeAdminForm-profileViewlabel-g_62c {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.ChangeAdminForm-profileViewMainContent-vDXI2 {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.ChangeAdminForm-reviewsFormStar-Qhixq {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.ChangeAdminForm-reviewsFormStar-Qhixq svg {
	cursor: pointer;
}

.ChangeAdminForm-addLanguageText-h13KB {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.ChangeAdminForm-exportSection-ELEOW {
		grid-template-columns: 100%;
	}

	.ChangeAdminForm-spaceTop52-KIygE {
		margin-top: 18px;
	}

	.ChangeAdminForm-exportText-bn5Vy {
		float: none;
		margin-top: 12px;
	}

	.ChangeAdminForm-exportSectionGridSub-OgKnf {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.ChangeAdminForm-profileViewlabel-g_62c {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.ChangeAdminForm-profileViewMainContent-vDXI2 {
		width: 100%;
		text-align: center;
	}

	.ChangeAdminForm-panelHeader-CiAXW {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `ChangeAdminForm-space1-GDWDq`,
	"space2": `ChangeAdminForm-space2-nGuZM`,
	"space3": `ChangeAdminForm-space3-QQjcU`,
	"space4": `ChangeAdminForm-space4-ZeU_9`,
	"space5": `ChangeAdminForm-space5-egjwl`,
	"space6": `ChangeAdminForm-space6-CdB5_`,
	"space7": `ChangeAdminForm-space7-fmGZR`,
	"space8": `ChangeAdminForm-space8-qA706`,
	"spaceTop1": `ChangeAdminForm-spaceTop1-a69MF`,
	"spaceTop2": `ChangeAdminForm-spaceTop2-lZk7g`,
	"spaceTop3": `ChangeAdminForm-spaceTop3-A5tc_`,
	"spaceTop4": `ChangeAdminForm-spaceTop4-Xh4_t`,
	"spaceTop5": `ChangeAdminForm-spaceTop5-Mhz_M`,
	"spaceTop6": `ChangeAdminForm-spaceTop6-OtApW`,
	"spaceTop7": `ChangeAdminForm-spaceTop7-rBPQh`,
	"spaceTop8": `ChangeAdminForm-spaceTop8-jAouD`,
	"noMargin": `ChangeAdminForm-noMargin-JDzRY`,
	"padding1": `ChangeAdminForm-padding1-dO8U3`,
	"padding2": `ChangeAdminForm-padding2-TQ4KQ`,
	"padding3": `ChangeAdminForm-padding3-ZebCC`,
	"padding4": `ChangeAdminForm-padding4-o1J_W`,
	"padding5": `ChangeAdminForm-padding5-es6lB`,
	"padding6": `ChangeAdminForm-padding6-xSByg`,
	"padding7": `ChangeAdminForm-padding7-HUdT8`,
	"paddingTop1": `ChangeAdminForm-paddingTop1-sXHch`,
	"paddingTop2": `ChangeAdminForm-paddingTop2-SwEp4`,
	"paddingTop3": `ChangeAdminForm-paddingTop3-DYx5K`,
	"paddingTop4": `ChangeAdminForm-paddingTop4-yXCIJ`,
	"paddingTop5": `ChangeAdminForm-paddingTop5-AXMnT`,
	"paddingTop6": `ChangeAdminForm-paddingTop6-hiYqV`,
	"paddingTop7": `ChangeAdminForm-paddingTop7-kMIJS`,
	"noPadding": `ChangeAdminForm-noPadding-OiBL1`,
	"spaceMarginBottom0": `ChangeAdminForm-spaceMarginBottom0-LPmIa`,
	"textBold": `ChangeAdminForm-textBold-hJe83`,
	"textBolder": `ChangeAdminForm-textBolder-gbz2B`,
	"textNormal": `ChangeAdminForm-textNormal-ZnARA`,
	"textDarkBlue": `ChangeAdminForm-textDarkBlue-xk8C0`,
	"textLightBlue": `ChangeAdminForm-textLightBlue-HDd0S`,
	"textLightSandleGreen": `ChangeAdminForm-textLightSandleGreen-jZ9MU`,
	"textLightBrown": `ChangeAdminForm-textLightBrown-tqZE5`,
	"textMediumMaroon": `ChangeAdminForm-textMediumMaroon-qw9yY`,
	"textBrown": `ChangeAdminForm-textBrown-QV5oC`,
	"textMaroon": `ChangeAdminForm-textMaroon-ePquF`,
	"textDarkBrown": `ChangeAdminForm-textDarkBrown-mnaAI`,
	"textMediumBrown": `ChangeAdminForm-textMediumBrown-DwXtP`,
	"textSkyBlue": `ChangeAdminForm-textSkyBlue-x6Qp9`,
	"textGray": `ChangeAdminForm-textGray-_yLr_`,
	"errorMessage": `ChangeAdminForm-errorMessage-T5nvt`,
	"userText": `ChangeAdminForm-userText-ctw1O`,
	"panelHeader": `ChangeAdminForm-panelHeader-CiAXW`,
	"exportSection": `ChangeAdminForm-exportSection-ELEOW`,
	"exportSectionGridSub": `ChangeAdminForm-exportSectionGridSub-OgKnf`,
	"exportText": `ChangeAdminForm-exportText-bn5Vy`,
	"exportLinkImg": `ChangeAdminForm-exportLinkImg-buQe_`,
	"exportImg": `ChangeAdminForm-exportImg-hlW1o`,
	"linkBtn": `ChangeAdminForm-linkBtn-WAfu3`,
	"table": `ChangeAdminForm-table-COYnj`,
	"tableRow": `ChangeAdminForm-tableRow-kKNrr`,
	"tableCell": `ChangeAdminForm-tableCell-CPbop`,
	"formGroup": `ChangeAdminForm-formGroup-bBxI3`,
	"marginTop0": `ChangeAdminForm-marginTop0-TzFEA`,
	"marginBottom20": `ChangeAdminForm-marginBottom20-nIDTm`,
	"bannerImageBg": `ChangeAdminForm-bannerImageBg-vR1DD`,
	"bannerDelete": `ChangeAdminForm-bannerDelete-rcQIj`,
	"exportLink": `ChangeAdminForm-exportLink-bu9tD`,
	"seachContent": `ChangeAdminForm-seachContent-sgtDD`,
	"marginBottom9": `ChangeAdminForm-marginBottom9-lAnEz`,
	"spaceTop52": `ChangeAdminForm-spaceTop52-KIygE`,
	"profileViewInner": `ChangeAdminForm-profileViewInner-RA5Lb`,
	"profileViewMain": `ChangeAdminForm-profileViewMain-QOvAb`,
	"profileViewlabel": `ChangeAdminForm-profileViewlabel-g_62c`,
	"profileViewMainContent": `ChangeAdminForm-profileViewMainContent-vDXI2`,
	"reviewsFormStar": `ChangeAdminForm-reviewsFormStar-Qhixq`,
	"addLanguageText": `ChangeAdminForm-addLanguageText-h13KB`
};
module.exports = ___CSS_LOADER_EXPORT___;
